import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  allBrokers: [],
  allCategories: [],
  allChannels: [],
  allVideos: [],
  noti_counter: 0,
};

const commonSlice = createSlice({
  name: "commonSlice",
  initialState,
  reducers: {
    setAllCommon(state, action) {
      state.allBrokers = action.payload?.allBrokers;
      state.allCategories = action.payload?.allCategories;
    },
    setAllChannels(state, action) {
      state.allChannels = action.payload;
    },
    setAllVideos(state, action) {
      state.allVideos = action.payload;
    },
    appendSingleVideo(state, action) {
      state.allVideos.push(action.payload);
    },
    appendSingleChannel(state, action) {
      state.allChannels.push(action.payload);
    },
    saveNotiData(state, action) {
      state.noti_counter += 1;
    },
    clearNotiData(state, action) {
      state.noti_counter = 0;
    },
  },
});

export const {
  setAllCommon,
  setAllChannels,
  setAllVideos,
  appendSingleVideo,
  appendSingleChannel,
  saveNotiData,
  clearNotiData,
} = commonSlice.actions;

export default commonSlice.reducer;
